module.exports = __webpack_public_path__ + "img/997019-1000232940000973-2286909807858371521-n-1-jpg.jpg";